<div class="cr-title">
    <div class="d-flex align-items-center">
        <cmps-icon
            class="mr-1"
            svgIcon="calendar-range"
        ></cmps-icon>
        <div class="cr-title-label">
            <div class="cr-title-name">
                <span>{{ _i18n._48_MANAGER | translate }}:&nbsp;</span>
                <span>{{
                    state?.manager?.firstName + ' ' + state?.manager?.lastName
                }}</span>
            </div>
            <div class="cr-title-schedule">
                {{ _i18n._9606_SCHEDULE | translate }}
            </div>
        </div>
    </div>
</div>
<ng-container [ngSwitch]="state?.view">
    <mwl-calendar-month-view
        *ngSwitchCase="'month'"
        [viewDate]="state?.viewDate"
        [events]="state?.calendarEvents"
        [refresh]="_refresh"
        (eventClicked)="eventClicked($event, $eventMouse)"
    >
    </mwl-calendar-month-view>
    <mwl-calendar-week-view
        *ngSwitchCase="'week'"
        [viewDate]="state?.viewDate"
        [events]="state?.calendarEvents"
        [headerTemplate]="headerWeekTpl"
        [hourSegmentTemplate]="hourSegmentWeekTpl"
        [eventTemplate]="eventWeekTpl"
        [refresh]="_refresh"
        (eventClicked)="eventClicked($event, $eventMouse)"
        (hourSegmentClicked)="hourEventClicked($event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-day-view
        *ngSwitchCase="'day'"
        [viewDate]="state?.viewDate"
        [events]="state?.calendarEvents"
        [refresh]="_refresh"
        (eventClicked)="eventClicked($event, $eventMouse)"
    >
    </mwl-calendar-day-view>
</ng-container>

<!--TODO month templates-->

<ng-template
    let-days="days"
    let-locale="locale"
    let-dayHeaderClicked="dayHeaderClicked"
    let-eventDropped="eventDropped"
    let-trackByWeekDayHeaderDate="trackByWeekDayHeaderDate"
    let-dragEnter="dragEnter"
    #headerWeekTpl
>
    <div
        class="cr-column-header-row-nav"
        role="row"
    >
        <div class="cr-column-header-cell-empty"></div>
        <div
            cmpsCalendarNavigation
            [view]="state?.view"
            (viewChange)="_onViewChange($event)"
            [viewDate]="state?.viewDate"
            (viewDateChange)="_onChangeNavigation($event)"
        ></div>
    </div>
    <div
        class="cr-column-header-row-date"
        role="row"
    >
        <div class="cr-column-header-cell-empty"></div>
        <ng-container
            *ngFor="let day of days; trackBy: trackByWeekDayHeaderDate"
        >
            <div
                class="cr-column-header-cell"
                [class.cr-column-header-cell-weekend]="day.isWeekend"
                [class.cr-column-header-cell-today]="day.isToday"
                role="columnheader"
            >
                <div class="cr-column-header-date-narrow">
                    {{ day.date | date: 'd' }}
                </div>
                <div class="cr-column-header-date-wide">
                    {{ day.date | date: 'EEEE' }}
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template
    let-segment="segment"
    let-locale="locale"
    let-segmentHeight="segmentHeight"
    let-isTimeLabel="isTimeLabel"
    let-daysInWeek="daysInWeek"
    #hourSegmentWeekTpl
>
    <div
        [class.cr-hour-segment]="!isTimeLabel"
        [class.cr-hour-segment-time]="isTimeLabel"
        [class.cr-hour-segment-weekend]="
            !isTimeLabel &&
            (segment.date.getDay() === 0 || segment.date.getDay() === 6)
        "
    >
        <div *ngIf="segment.isStart && isTimeLabel">
            {{ segment.displayDate | date: 'h aaa' }}
        </div>
    </div>
</ng-template>

<ng-template
    let-weekEvent="weekEvent"
    let-tooltipPlacement="tooltipPlacement"
    let-eventClicked="eventClicked"
    let-tooltipTemplate="tooltipTemplate"
    let-tooltipAppendToBody="tooltipAppendToBody"
    let-tooltipDisabled="tooltipDisabled"
    let-tooltipDelay="tooltipDelay"
    let-column="column"
    let-daysInWeek="daysInWeek"
    #eventWeekTpl
>
    <!--(weekEvent.tempEvent || weekEvent.event)-->
    <div
        class="cr-event-wrapper"
        [style.background-color]="weekEvent.event.meta.eventStatusColour"
        tabindex="0"
        role="button"
        (mwlClick)="eventClicked.emit({ sourceEvent: $event })"
        (mwlKeydownEnter)="eventClicked.emit({ sourceEvent: $event })"
    >
        <div class="cr-event-stripe-bg"></div>
        <div class="cr-event-name">
            {{
                weekEvent.event.meta.performerFirstName +
                    ' ' +
                    weekEvent.event.meta.performerLastName
            }}
        </div>
        <div
            class="cr-event-event"
            [style.background-color]="weekEvent.event.meta.eventStatusColour"
        >
            <div class="cr-event-event-name">
                {{ weekEvent.event.meta.eventName }}
            </div>
            <cmps-icon
                class="ml-1"
                svgIcon="calendar-range"
            ></cmps-icon>
        </div>
    </div>
</ng-template>

<!--TODO day templates-->
